import { Component, Injectable, ErrorHandler, OnInit } from "@angular/core";

import {
  Platform,
  MenuController,
  NavController,
  ModalController,
  AlertController,
} from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { NativeStorage } from "@ionic-native/native-storage/ngx";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";

import { TranslateService } from "@ngx-translate/core";
import { Globalization } from "@ionic-native/globalization/ngx";
import {
  LANGUAGE,
  CONSTANTS,
  APIS,
  ProfileInfo,
  constantsJson,
} from "./core/constants/constants";
import { UTILITIES } from "./core/utility/utilities";
import { Storage } from "@ionic/storage";
import { FireAuthService } from "./shared/auth.service";
import { AppService } from "./app.service";
import { Network } from "@ionic-native/network/ngx";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { InAppService } from "./inapp.service";
import { HTTP } from "@ionic-native/http/ngx";
import moment from "moment";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { AngularFireAuth } from "@angular/fire/auth";
import * as firebase from "firebase";
import { Location } from "@angular/common";

import { InAppPurchase } from "@ionic-native/in-app-purchase/ngx";
import { RatingPopupComponent } from "./components/rating-popup/rating-popup.component";
import { NoInternetComponent } from "./components/no-internet/no-internet.component";

import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { UserOptions } from "jspdf-autotable";
import { File } from "@ionic-native/file/ngx";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { Keyboard } from "@ionic-native/keyboard/ngx";

import { Deeplinks } from "@awesome-cordova-plugins/deeplinks/ngx";
// import { Deeplinks } from "@ionic-native/deeplinks";
import { ConsumePage } from "./consume/consume.page";
// import * as data from ".//assets/notification.json";
// import * as data from "./../assets/notification.json";
import { NewHomePage } from "./newUi/pages/new-home/new-home.page";
//import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
// import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
//import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
//import OneSignal from 'onesignal-cordova-plugin';
import { NewDietPage } from "./newUi/pages/new-diet/new-diet.page";
import { NewActivityPage } from"./newUi/pages/new-activity/new-activity.page";
import { SearchPage } from "./newUi/pages/search/search.page";
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
// import { INotificationPayload } from 'cordova-plugin-fcm-with-dependecy-updated';
// import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
// import OneSignal from 'onesignal-cordova-plugin';
// import { INotificationPayload } from 'cordova-plugin-fcm-with-dependecy-updated';
// import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  providers: [Location, InAppBrowser],
})
export class AppComponent implements OnInit {
  private deviceLanguage: string;
  profileName: any = "";
  profileInititals: any = "";
  profilePic: any = "";
  expiryDate: any = "";
  isLogout = false;
  isMnfight = false;
  showSplash = false;
  planData: any = { isPlanActive: false };
  interval: any;
  keyMantraInterval: any;
  text: string = "Flamenco";
  imgurl: string =
    "https://cdn.pixabay.com/photo/2019/12/26/05/10/pink-4719682_960_720.jpg";
  link: string = "https://link.medium.com/JA4amAHFJ5";
  isIOSDevice = false;
  isIosDevice = this.utilities.isDeviceiOS();
  isAndroidDevice = this.utilities.isDeviceAndroid();
  notificationList: any = [];
  notification: any = {};

  public hasPermission: boolean;
  public token: string;
  isDesktop: boolean = false;

  constructor(
    // private socialSharing: SocialSharing,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private nativeStorage: NativeStorage,
    private translate: TranslateService,
    private globalization: Globalization,
    private storage: Storage,
    private utilities: UTILITIES,
    private menuController: MenuController,
    private fireAuthService: FireAuthService,
    private appService: AppService,
    private network: Network,
    private navCtrl: NavController,
    private httpClient: HttpClient,
    private inApp: InAppService,
    private http: HTTP,
    private iab: InAppBrowser,
    private afAuth: AngularFireAuth,
    private location: Location,

    private iap: InAppPurchase,
    private modalController: ModalController,
    private file: File,
    private fileOpener: FileOpener,
    private route: ActivatedRoute,
    public keyboard: Keyboard,
    private deeplinks: Deeplinks,
    //public oneSignal: OneSignal,
    private firebaseX: FirebaseX,
  ) {
    if(this.platform.is("android") || this.platform.is("ios") || (this.platform.is("android") && this.platform.is("mobileweb")) || (this.platform.is("ios") && this.platform.is("mobileweb"))) {
      this.initializeApp();
      this.platform.ready().then(() => {
        //this.OneSignalInit();
        this.setupFCM();
      });
      this.isDesktop = false;
      this.router.events.subscribe((ev) => {
        if (ev instanceof NavigationEnd) {
          //  // console.log(ev.url);
          if (ev.url == "/tabs/new-home") {
            this.menuController.enable(true);
            this.storage.get("newProfilePic").then((val) => {
              // console.log("profile pic", val);
              if (val != "" && val != null) {
                let data = JSON.parse(val);
                // console.log("datat", data);

                if (data != undefined && data != null) {
                  this.profileName = data.firstName + " " + data.lastName;
                  this.profileInititals =
                    data.firstName.charAt(0).toUpperCase() +
                    data.lastName.charAt(0).toUpperCase();
                  ProfileInfo.profileName = data.firstName + " " + data.lastName;
                  this.profilePic = ProfileInfo.profilePic = data.photoUrl;
                }
              }
              this.getWordPressFaq();
            });
          } else {
            this.menuController.enable(false);
          }
          // console.log("NavigateEnd", ev);
          if (ev.url == "/tabs/new-home") {
            this.checkCurrentPlan();
          }
          if (
            ev.url == "/edit-profile" ||
            ev.url == "/news" ||
            ev.url == "/blog" ||
            ev.url == "/profile"
          ) {
            CONSTANTS.dietDate = null;
            // CONSTANTS.country = null;
          }
        }
      });

      this.appService.downloadDietPlan$.subscribe(() => {
        let self = this;
        setTimeout(() => {
          self.downloadDietPlan();
        }, 100);
      });

      this.appService.expDateUpdated$.subscribe(() => {
        this.checkCurrentPlan();
      });

      this.appService.showRateUS$.subscribe(() => {
        let self = this;
        setTimeout(() => {
          // console.log("Showing rate us");
          localStorage.setItem("showRateUsPopupShowed", "true");
          this.storage.get("ProfileData").then((res) => {
            if (res && res != "") {
              self.rateus();
            }
          });
        }, 180000);
      });
    } else {
      this.isDesktop = true;
      console.log('desktop: ', this.platform.is('desktop'));
      let ele = document.getElementsByTagName('body');
      ele[0].style.pointerEvents = "none"
      // this.router.navigate(["landing-slider"]);
      return
    }
  }

  // OneSignalInit(): void {
  //   // Uncomment to set OneSignal device logging to VERBOSE  
  //   // OneSignal.setLogLevel(6, 0);

  //   // NOTE: Update the setAppId value below with your OneSignal AppId.
  //   OneSignal.setAppId("c5af6d12-4d99-4dd8-807c-c1cd04c5ad81"); // Naitik's Account id
  //   //OneSignal.setAppId("3589d68a-6043-439c-ba5a-b0023c63c5fc");
  //   OneSignal.setNotificationOpenedHandler(function (jsonData) {
  //     console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
  //   });

  //   // Prompts the user for notification permissions.
  //   //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
  //   OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
  //     console.log("User accepted notifications: " + accepted);
  //   });
  // }

  gup(name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results == null ? null : results[1];
  }

  dateCompare(firstDate, secondDate) {
    if (firstDate.setHours(0, 0, 0, 0) - secondDate.setHours(0, 0, 0, 0) == 0) {
      //first date is in future, or it is today
      return "equal";
    } else if (
      firstDate.setHours(0, 0, 0, 0) - secondDate.setHours(0, 0, 0, 0) >
      0
    ) {
      return "greater";
    } else {
      return "less";
    }
  }

  creationDate;
  profileExpiryDate;
  currentDate;
  isPlanActive = false;
  freePlanActive = false;
  premiumPlanActive = false;
  premiumPlanExpired = false;

  checkCurrentPlan() {
    if (localStorage.getItem("tkn") != "") {
      this.appService.getOnePlan().then(
        (res) => {
          this.planData = res;
          // CONSTANTS.isPlanActiveParent = this.planData.isPlanActive;
          this.creationDate = new Date(res["profile"]["createdDate"]);
          this.profileExpiryDate = new Date(res["planExpiryDate"]);
          this.currentDate = new Date();

          if (
            this.dateCompare(this.profileExpiryDate, this.currentDate) ==
            "greater"
          ) {
            this.freePlanActive = false;
            this.premiumPlanActive = true;
            this.premiumPlanExpired = false;
          } else if (
            this.dateCompare(this.profileExpiryDate, this.creationDate) ==
              "equal" ||
            this.dateCompare(
              this.profileExpiryDate,
              new Date(new Date(this.planData.profile.createdDate))
            ) == "equal"
          ) {
            this.freePlanActive = true;
            this.premiumPlanActive = false;
            this.premiumPlanExpired = false;
          } else if (
            this.dateCompare(this.profileExpiryDate, this.currentDate) == "less"
          ) {
            this.freePlanActive = false;
            this.premiumPlanActive = false;
            this.premiumPlanExpired = true;
          } else if (
            this.dateCompare(this.profileExpiryDate, this.currentDate) ==
            "equal"
          ) {
            this.freePlanActive = false;
            this.premiumPlanActive = false;
            this.premiumPlanExpired = true;
          }
        },
        (err) => {}
      );
    }

    this.getProfileData();
  }

  isAvailableReffer = false;
  getProfileData() {
    this.appService.getProfile().then((profileData: any) => {
      // console.log("profileData:-", profileData);
      this.initAllFuncLoad();
      this.storage.set("profileData", this.utilities.parseString(profileData));
      CONSTANTS.email = profileData?.profile?.email;
      CONSTANTS.name = profileData?.profile?.name;
      CONSTANTS.dietDate = moment(new Date()).format("DDMMYYYY");
      if (localStorage.getItem(CONSTANTS.dietDate)) {
        const isDetox: any = localStorage.getItem(CONSTANTS.dietDate);
        CONSTANTS.isDetox = JSON.parse(isDetox);
      }
      this.isAvailableReffer =
        profileData &&
        profileData["profile"] &&
        profileData["profile"]["isReferral"];
      // this.isAvailableReffer = ((profileData && profileData["profile"] && profileData["profile"]["isReferral"]) || (CONSTANTS.email == "puneet0205@gmail.com" || CONSTANTS.email == "fakesarthak@gmail.com"));
    });
  }

  ngOnInit() {
    // console.log("didEnter");
  }

  terms() {
    this.router.navigate(["terms"]);
  }
  unSubscribe() {
    this.router.navigate(["unsubscribe"]);
  }
  gotoUpgrade() {
    this.router.navigate(["upgrade-plan"]);
  }

  cancelPlan() {
    this.router.navigate(["cancel-start"]);
  }

  logout() {
    this.fireAuthService.SignOut().then(
      (res) => {
        CONSTANTS.isDetox = false;
        this.isMnfight = false;
        this.storage.set("dietData", null);
        this.storage.set("optionsData", null);
        this.storage.set("lessThan100Data", null);
        this.storage.set("highProteinData", null);
        this.storage.set("healthData", null);
        this.storage.set("newProfilePic", null);
        this.storage.set("localData", "");
        this.storage.set("profile", "");
        this.storage.set("ProfileData", "");
        this.storage.set("Token", "");
        localStorage.setItem("isPlanSubscribe", "");
        localStorage.setItem("tkn", "");
        localStorage.setItem("isExpiredMsg", "");
        this.storage.remove("diets");
        this.storage.remove("slotTiming");
        this.storage.remove("iosPlan");
        localStorage.removeItem("isDetox");
        this.storage.remove("caloriesFit");
        this.storage.remove("week_calories");
        this.storage.remove("day_calories");
        this.storage.remove("month_calories");
        this.storage.remove("week_steps");
        this.storage.remove("day_steps");
        this.storage.remove("month_steps");
        this.storage.remove("puchase_plan");
        this.storage.remove("toDoList");
        this.storage.remove("toDoDate");
        this.storage.remove("wellnessbox_address");
        this.storage.remove("highProtienData");
        localStorage.removeItem("modalOpen");
        localStorage.removeItem("visitedPost");
        localStorage.removeItem("refreshCounter");
        localStorage.removeItem("couponCounter");
        localStorage.removeItem("loadAllDataAt");
        localStorage.removeItem("loadAllDataAtConsume");
        localStorage.removeItem("randomLockCounter");
        localStorage.removeItem("loadAllDataAtSubBottom");
        localStorage.removeItem("couponCounter");
        localStorage.removeItem("offerTimeExpired");
        localStorage.removeItem("refferData");
        localStorage.removeItem("showRateUsPopup");
        localStorage.removeItem("showRateUsPopupShowed");
        localStorage.removeItem("freeTrialSet");
        localStorage.removeItem("freeTrialStartedAt");
        localStorage.removeItem("rating");
        localStorage.removeItem("startActivity");
        localStorage.removeItem("onFast");
        localStorage.removeItem("fastDate");
        localStorage.removeItem("fastStartTime");
        localStorage.removeItem("fastDuration");
        localStorage.removeItem("isCorporateUser");
        localStorage.removeItem("razorPayClicked");
        localStorage.removeItem("surveyOpend");
        localStorage.removeItem("loadHighProtienData");
        localStorage.removeItem("fromToken");
        this.statusBar.backgroundColorByHexString("#f2786d"); // "#FFC048" //"#01A3A4"
        this.statusBar.overlaysWebView(false);
        this.router.navigate(["profile"], {
          queryParams: {
            logout: true,
          },
        });
      },
      (err) => {}
    );
  }

  /**Not used */
  readStatus() {
    this.storage.get("iosPlan").then((res: any) => {
      if (res) {
        CONSTANTS.isPlanActiveParent = this.planData.isPlanActive =
          res.isPlanActive;
        this.expiryDate = res.planExpiryDate;
      }
    });
  }

  async rateus() {
    const modal = await this.modalController.create({
      component: RatingPopupComponent,
      backdropDismiss: true,
      cssClass: "app-rating-popup",
      // componentProps: { data: data, profileData: profileData, country: country }
    });

    return await modal.present();
  }

  noInternetOpened = false;
  async noInternet() {
    if (!this.noInternetOpened) {
      const modal = await this.modalController.create({
        component: NoInternetComponent,
        backdropDismiss: true,
        cssClass: "app-rating-popup",
        // componentProps: { data: data, profileData: profileData, country: country }
      });

      modal.onDidDismiss().then((data: any) => {
        // console.log("Internet back.. Now reloading app....");
        this.noInternetOpened = false;
        this.initializeApp();
      });

      this.noInternetOpened = true;
      return await modal.present();
    }
  }

  restore() {
    // TO VERIFY RESTORED  PURCHASE STATES
    this.utilities.showLoading();
    // console.log("Resored clicked");
    let me = this;
    me.iap
      .restorePurchases()
      .then((purchases) => {
        // console.log("purchases", purchases);
        if (purchases && purchases.length > 0) {
          let obj = {};
          obj["purchase"] = purchases;
          me.afAuth.authState.subscribe((user) => {
            if (user) {
              let plans = firebase
                .firestore()
                .collection("user_plan_restore")
                .doc(user.uid);
              plans
                .set(obj)
                .then((result) => {
                  me.utilities.hideLoader();
                  alert("Subscriptions Restored");
                })
                .catch(function (error) {
                  me.utilities.hideLoader();
                  // console.log(`logLevel:2 ${error}`);
                  alert("Subscriptions Restore Error" + JSON.stringify(error));
                });
            } else {
              me.utilities.hideLoader();
              alert("No User Found for restore.");
            }
          });
        } else {
          me.utilities.hideLoader();
          alert("No Previous Subscriptions for Resotred");
        }
      })
      .catch((err) => {
        me.utilities.hideLoader();
        alert("Subscriptions Restore Error" + JSON.stringify(err));
        // console.log("Subscriptions Restore Error", JSON.stringify(err));
      });
  }

  loadFBEvents() {
   // this.fb.setAutoLogAppEventsEnabled(true);
  }


  defaultData: any = {};
  tokenBaseNavigation(token) {
    // let actualToken = JSON.parse(this.utilities.parseString(token))
    // .access_token;

    setTimeout(() => {
      this.appService.getHabitsForUpdate().then(
        (res) => {
          this.appService.getDefaultData(token).then(
            (res) => {
            //  debugger;
              this.defaultData = JSON.parse(JSON.stringify(res));
              this.storage.set("graph", "");
              this.appService.getProfile().then(
                (profileData) => {
                  if (
                    profileData &&
                    profileData["profile"] &&
                    profileData["profile"].dietPlanType
                  ) {
                    this.defaultData.otherMaster.type.filter((ele) => {
                      if (profileData["profile"].dietPlanType == ele.name)
                        return (ele.isSelected = true);
                    });
                  }
                  if (
                    profileData &&
                    profileData["lifeStyle"] &&
                    profileData["lifeStyle"].prefWorkOutTime
                  ) {
                    this.defaultData.otherMaster.workoutTime.filter((ele) => {
                      if (profileData["lifeStyle"].prefWorkOutTime == ele.name)
                        return (ele.isSelected = true);
                    });
                  }

                  this.storage.set(
                    "localData",
                    this.utilities.parseString(this.defaultData)
                  );
                  const data = Object.assign({}, this.defaultData);
                  const prof = Object.assign({}, profileData);
                  const profile = JSON.parse(JSON.stringify(profileData));
                  // console.log("profile:-", prof);

                  this.storage.set(
                    "profileData",
                    this.utilities.parseString(prof)
                  );
                  localStorage.setItem(
                    "isPlanSubscribe",
                    profile.isPlanSubsCribe
                  );
                  if (
                    profile.demographic == undefined ||
                    profile.lifeStyle == undefined ||
                    profile.diet == undefined
                  ) {
                    this.fillDemographic(data, prof);
                  } else {
                    this.router.navigate(["tabs/new-home"]);
                  }
                },
                (profileError) => {
                  // this.processing = false;
                  // console.log("profileError,", profileError.status);
                  if (profileError.status == 401) {
                    // this.gotoGoogle();
                  }
                }
              );

              // this.getProfile(this.user);
            },
            (err) => {
              // this.processing = false;
              // console.log("errrrrr:-", err);
            }
          );
        },
        (err) => {
          // this.processing = false;
        }
      );
    }, 100);
  }

  async fillDemographic(data, profile) {
    const uGender = this.utilities.updateDemographicData(
      data.otherMaster?.gender,
      profile.demographic?.gender,
      false
    );
    data.otherMaster.gender = uGender;
    data.otherMaster.height = [
      {
        ind: profile.demographic?.height?.ind,
        value: profile.demographic?.height?.value,
        param: profile.demographic?.height?.unit,
        ischecked: profile.demographic?.height?.ischecked,
      },
    ];
    data.otherMaster.weight = [
      {
        ind: profile.demographic?.weight?.ind,
        value: profile.demographic?.weight?.value,
        param: profile.demographic?.weight?.unit,
        ischecked: profile.demographic?.weight?.ischecked,
      },
    ];
    if (data.otherMaster.ageMaster != undefined) {
      const uAge = this.utilities.updateDemographicData(
        data.otherMaster?.ageMaster?.data,
        profile.demographic?.age,
        true
      );
      data.otherMaster.ageMaster.data = uAge;
    }
    data.otherMaster.bmi = {
      bmi: profile.demographic?.bmi,
      suggestedWeight: profile.demographic?.suggestedWeight,
    };
    if (profile.lifeStyle != undefined) {
      await this.fillLifeStyle(data, profile);
    } else {
      await this.storage.set("localData", this.utilities.parseString(data));
      await this.router.navigate(["boarding1"]);
    }
  }
  async fillLifeStyle(dt, profile) {
    const uactivities = this.utilities.updateDemographicData(
      dt.otherMaster.activities,
      profile.lifeStyle.activities,
      false
    );
    dt.otherMaster.activities = uactivities;

    const ucommunity = this.utilities.updateDataMultiSeletion(
      dt.otherMaster.community,
      profile.lifeStyle.communities,
      true
    );
    dt.otherMaster.community = ucommunity;
    const ufoodPref = this.utilities.updateLifeStyleDataForSingleValue(
      dt.otherMaster.foodPref,
      profile.lifeStyle?.foodType,
      false
    );
    dt.otherMaster.foodPref = ufoodPref;

    const uWakeup = this.utilities.updateLifeStyleDataForTime(
      dt.otherMaster.wakeup.data,
      profile.lifeStyle.wakeup,
      true
    );

    // const uSleep = this.utilities.updateLifeStyleDataForTime(
    //   dt.otherMaster.sleep.data,
    //   profile.lifeStyle.sleep,
    //   true
    // );

    const uLeaveforOffice = this.utilities.updateLifeStyleDataForTime(
      dt.otherMaster.leaveForOffice,
      profile.lifeStyle.leaveForOffice,
      false
    );
    dt.otherMaster.leaveForOffice = uLeaveforOffice;

    // const uComeBack = this.utilities.updateLifeStyleDataForTime(
    //   dt.otherMaster.comeBack,
    //   profile.lifeStyle.comeBack,
    //   false
    // );
    // dt.otherMaster.comeBack = uComeBack;

    const uHealths = this.utilities.updateDataMultiSeletion(
      dt.otherMaster.diseases,
      profile.lifeStyle.diseases,
      true
    );

    dt.otherMaster.wakeup.data = [];
    dt.otherMaster.wakeup.data = uWakeup;

    // dt.otherMaster.sleep.data = [];
    // dt.otherMaster.sleep.data = uSleep;

    dt.otherMaster.diseases = [];
    dt.otherMaster.diseases = uHealths;

    const suggestedCalories = this.utilities.updateSuggestdCalories(
      profile.lifeStyle,
      true
    );

    dt.otherMaster.calories = suggestedCalories;
    // console.log("suggestedCalories", suggestedCalories);

    const dataLife = Object.assign({}, dt);

    if (profile.diet != undefined) {
      this.fillDiet(dataLife, profile);
    } else {
      await this.storage.set("localData", JSON.stringify(dataLife));
      await this.router.navigate(["boarding1"]);
    }
  }
  async fillDiet(dt, profile) {
    // console.log("dietFrofile", profile);

    const food = this.utilities.updateDataMultiSeletion(
      dt.otherMaster.food.data,
      profile.diet.food,
      false
    );
    dt.otherMaster.food.data = food;

    const drinks = this.utilities.updateDataMultiSeletion(
      dt.Master.drinks,
      profile.diet.drinks,
      true
    );
    const snacks = this.utilities.updateDataMultiSeletion(
      dt.Master.snacks,
      profile.diet.snacks,
      true
    );
    const fruits = this.utilities.updateDataMultiSeletion(
      dt.Master.fruits,
      profile.diet.fruits,
      true
    );
    const dishes = this.utilities.updateDataMultiSeletion(
      dt.Master.dishes,
      profile.diet.dishes,
      true
    );
    const pules = this.utilities.updateDataMultiSeletion(
      dt.Master.plscurries,
      profile.diet.pules,
      true
    );
    const rice = this.utilities.updateDataMultiSeletion(
      dt.Master.rice,
      profile.diet.rice,
      false
    );

    dt.otherMaster.diet = {
      suggestedWeight: profile.diet.suggestedWeight,
      dateBy: profile.diet.dateBy,
    };
    const diet = Object.assign({}, dt);
    this.storage.set("localData", JSON.stringify(diet));
    if (profile.isPlanSubsCribe) {
      // if (!this.habitList.isHabitApplicableForToday) {
      //   this.utilities.hideLoader();
      //   await this.router.navigate(["unlock-plan"]);
      // } else {
      this.utilities.hideLoader();
      await this.router.navigate(["consume"]);
      // }
    } else {
      this.utilities.hideLoader();
      await this.router.navigate(["diet"]);
    }
  }

  loadQnAData() {}

  toggleAppTheme() {
    document.body.setAttribute("color-theme", "newDesign");
    // if (this.selectedTheme == 'default-theme') {
    //   this.settings.setActiveTheme('sbi-theme');
    //   // console.log("this.selectedTheme :- ",this.selectedTheme);

    // } else {
    //   this.settings.setActiveTheme('default-theme');
    // }
  }

  oneSignalNotification()
  {
    // this.oneSignal.startInit('AAAAb0JnkQA:APA91bEBZYQz0EQktMODNGd15LqZ7nPrvVc_XMMwUw3RxTYZp_sTniOyWn98pm0bR8-Y1BJOMBPB981LkI_nGYYn84k4sSTpKPDGzEziysHbX2WRGM2EhFV4OTIAJHaGQCXAYFuFuneg', '477855453440');

    // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);

    // this.oneSignal.handleNotificationReceived().subscribe(() => {
    //   // do something when notification is received
    // });

    // this.oneSignal.handleNotificationOpened().subscribe(() => {
    //   // do something when a notification is opened
    // });

    // this.oneSignal.endInit();


  }

  initializeApp() {
    this.oneSignalNotification();
    this.statusBar.backgroundColorByHexString("#f2786d");
    this.statusBar.overlaysWebView(false);
    //this.settings.getActiveTheme().subscribe(val => this.selectedTheme = val);
    this.toggleAppTheme();
    if (
      (window && window.navigator && window.navigator.onLine) ||
      (navigator &&
        navigator["connection"] &&
        navigator["connection"]["type"] != "none")
    ) {
      this.isIOSDevice = this.utilities.isDeviceiOS();
      let me = this;
      this.platform.ready().then(() => {
        this.statusBar.backgroundColorByHexString("#f2786d");
        this.statusBar.overlaysWebView(false);
        this.loadFBEvents();

        if (this.gup("token", location.href)) {
          let token = this.gup("token", location.href);
          this.storage.set("Token", token);
          localStorage.setItem("tkn", token);
          localStorage.setItem("visited", "visited");
          localStorage.setItem("fromToken", "true");
          this.appService.getProfile().then((profileData) => {
            let userData = {
              authToken: token,
              email: profileData["profile"]["email"],
              firstName: profileData["profile"]["given_name"],
              id: profileData["profile"]["email"],
              idToken: token,
              lastName: profileData["profile"]["family_name"],
              name: profileData["profile"]["name"],
              photoUrl: null,
              provider: "mobile",
            };

            this.storage.set("newProfilePic", JSON.stringify(userData));
            this.tokenBaseNavigation(token);
            // this.isAvailableReffer = ((profileData && profileData["profile"] && profileData["profile"]["isReferral"]) || (CONSTANTS.email == "puneet0205@gmail.com" || CONSTANTS.email == "fakesarthak@gmail.com"));
          });
          // } else if (localStorage.getItem("visited") == "visited") {
          //   // this.router.navigate(["water-intake"]);
          //   // console.log("fillDemographic CLLLED");
          //   // this.storage.get("pendingPage").then((res) => {
          //   //   // console.log("pending page res", res);
          //   //   if (res) {
          //   //     this.router.navigate([res]);
          //   //   } else {
          //   //     this.router.navigate(["profile"]);
          //   //   }
          //   // });
          //   this.router.navigate(["profile"]);
          //   // this.router.navigate(["landing-slider"]);
        } else {
          let user = location.href.split("user=", location.href.length)[1];
          if (user) {
            this.router.navigate(["landing-slider"], {
              queryParams: { user: user },
            });
          } else {
            if (localStorage.getItem("tkn")) {
              this.storage.get("pendingPage").then((res) => {
                console.log("pending page res", res);
                if (res) {
                  this.getProfileData();
                  this.router.navigate([res]);
                } else {
                  this.getProfileData();
                  this.router.navigate(["tabs/new-home"]);
                  // this.router.navigate(["premium-member"]);
                }
              });
            } else {
              if (localStorage.getItem("visited") === "visited") {
                this.router.navigate(["profile"]);
              } else {
                this.router.navigate(["landing-slider"]);
              }
            }
          }
        }
        // me.checkCurrentPlan();
        // me.checkPlanStatus();
        this.network.onDisconnect().subscribe(() => {
          // this.utilities.presentAlert("Oops! No Internet!");
          this.noInternet();
          // console.log("network was disconnected :-(");
        });

        let connectSubscription = this.network.onConnect().subscribe(() => {
          // console.log("network connected!");
          setTimeout(() => {
            if (this.network.type === "wifi") {
              // console.log("we got a wifi connection.");
            }
          }, 3000);
        });
        connectSubscription.unsubscribe();

        this.translate.setDefaultLang(LANGUAGE.EN);
        this.getDeviceLanguage();
        this.statusBar.backgroundColorByHexString("#f2786d");
        this.statusBar.overlaysWebView(false);
        // this.statusBar.backgroundColorByHexString("#01A3A4");
        //this.statusBar.styleDefault();
        this.splashScreen.hide();

        this.loadAllData();

        me.getKeymantraPosts();
        this.keyMantraInterval = setInterval(function doSomething() {
          me.getKeymantraPosts();
        }, 1000 * 60 * 60 * 2);
        let self =this;
        setTimeout(() => {
          self.setupDeepLinks();
        }, 2000);
        
      });
    } else {
      // this.utilities.presentAlert("Oops! No Internet.");
      this.noInternet();
      let me = this;
      setTimeout(() => {
        me.utilities.hideLoader();
      }, 1000);
    }
  }

  setupDeepLinks(){
    // this.deeplinks
    //   .route({
    //     "/consume": NewHomePage,
    //     "/new-home": NewHomePage,
    //     "/universal-links-test": NewHomePage,
    //     "/new-diet": NewDietPage,
    //     "/new-activity": NewActivityPage,
    //     "/search": SearchPage,
    //   })
    //   .subscribe(
    //     (match) => {
    //       console.log("Successfully matched route", match);
    //       this.router.navigate([match.$link.path]);
    //     },
    //     (nomatch) => {
    //       // nomatch.$link - the full link data
    //       console.error("Got a deeplink that didn't match", nomatch);
    //     }
    //   );
  }

  firstDateIsPastDayComparedToSecond(firstDate, secondDate) {
    if (firstDate.setHours(0, 0, 0, 0) - secondDate.setHours(0, 0, 0, 0) >= 0) {
      //first date is in future, or it is today
      return false;
    }
    return true;
  }

  initAllFuncLoad() {
    this.storage.set("isTodaysLog", new Date().getDate().toString());
    // console.log("isTodaysDate", new Date().getDate().toString());
    localStorage.removeItem("isAnalysisPageVisited");
    // this.getWordPressPosts();
    this.getWordPressNews();

    this.getWordPressPurchasePlans();
    this.getWordAppIntro();
    this.getWordPressWaterTips();
  }


  getWordPressPosts() {
    let arrCode = [];
    // console.log("wordpresssss app module");

    this.storage.get("profileData").then((profile) => {
      const tempProf = JSON.parse(profile);

      if (tempProf.lifeStyle.diseases.includes("D")) {
        arrCode.push(242);
      }
      if (tempProf.lifeStyle.diseases.includes("C")) {
        arrCode.push(245);
      }
      if (tempProf.lifeStyle.diseases.includes("B")) {
        arrCode.push(244);
      }
      if (tempProf.profile.dietPlanType === "muscleGain") {
        arrCode.push(246);
      }
      if (tempProf.profile.dietPlanType === "fatShredding") {
        arrCode.push(246);
        arrCode.push(78);
      }
      if (
        tempProf.profile.dietPlanType === "weightLoss" ||
        tempProf.profile.dietPlanType === "maintenance"
      ) {
        arrCode.push(78);
      }

      if (arrCode.length == 0) {
        arrCode.push(78);
      }
      // console.log("wordpresssss1 app module");
      this.appService.getWordPressCategories(
        arrCode,
        this.utilities.isDeviceiOS(),
        (posts) => {
          // // console.log("wordpresssss2 app module:-",JSON.parse(posts));
          let totalPost: any = [];

          for (let index = 0; index < arrCode.length; index++) {
            totalPost.push(posts[index]);
          }
          // console.log("all post app module:--", totalPost.flat(1));
          this.storage.set("posts", totalPost.flat(1));
        }
      );
    });
  }

  loadAllData() {
    this.initAllFuncLoad();
    if (!localStorage.getItem("loadAllDataAt")) {
      localStorage.setItem("loadAllDataAt", new Date().toString());
      //    this.initAllFuncLoad();
    } else if (
      this.firstDateIsPastDayComparedToSecond(
        new Date(localStorage.getItem("loadAllDataAt")),
        new Date()
      )
    ) {
      localStorage.setItem("loadAllDataAt", new Date().toString());
      //    this.initAllFuncLoad();
    }
  }

  getKeymantraPosts() {
    if (this.utilities.isDeviceiOS()) {
      this.httpClient
        .get(APIS.WP_BASEURL + "?include[]=4256")
        .subscribe((data: any) => {
          let me = this;
          let post = JSON.parse(data.data);
          this.storage.set("key_mantra_post", post[0]);
        });
    } else {
      this.appService.getByPostId(4256).then((res: any) => {
        this.storage.set("key_mantra_post", res[0]);
      });
    }
  }

  getWordPressFaq() {
    this.appService.getFAQ().subscribe(
      (faq) => {
        this.storage.set("faq", faq);
      },
      (err) => {
        // console.log("Wordpress api Error faq: ", JSON.stringify(err));
      }
    );
  }

  getWordPressWaterTips() {
    this.appService.tips().subscribe(
      (water_tips) => {
        this.storage.set("water_tips", water_tips);
      },
      (err) => {
        // console.log("Wordpress api Error tips: ", JSON.stringify(err));
      }
    );
  }

  getWordPressPurchasePlans() {
    let color = [
      "#2980B9",
      "#27AE60",
      "#FD3A69",
      "#9D0191",
      "#403E7F",
      "#FF872C",
    ];
    let offerColor = "#DEB221";
    this.appService.getCouponList().subscribe(
      (puchase_plan) => {
        puchase_plan["couponList"].sort(function (a, b) {
          return a.discountedAmount - b.discountedAmount;
        });
        puchase_plan["couponList"].forEach((element, index) => {
          element["color"] = color[index];
        });
        puchase_plan["couponList"] = puchase_plan["couponList"].filter(
          (ele) => {
            return ele.perid != 3;
          }
        );
        for (let i = puchase_plan["couponList"].length - 1; i >= 0; i--) {
          if (
            puchase_plan["couponList"][i]["couponCode"].indexOf("wellness") > -1
          ) {
            puchase_plan["couponList"][i]["color"] = offerColor.toString();
          }
        }
        this.storage.set("puchase_plan", puchase_plan);
        // if(localStorage.getItem("refferData")) this.getOfferPlan(puchase_plan["couponList"]);
      },
      (err) => {
        // console.log("Wordpress api Error purchase plan: ", JSON.stringify(err));
      }
    );
  }

  getWordAppIntro() {
    let profile = CONSTANTS.profile;
    let postId = "";
    if (
      profile &&
      (profile.planType == "trial" || profile.planType == "trialEnd")
    ) {
      postId = "4281";
    } else {
      postId = "4283";
    }
    if (this.utilities.isDeviceiOS()) {
      this.http
        .get(APIS.WP_BASEURL + "?include[]=" + postId, {}, {})
        .then((data: any) => {
          let post = JSON.parse(data.data);
          // this.content = post[0].content.rendered;
          this.storage.set("app_intro", post);
        })
        .catch((error) => {
          // error message as string
          // console.log("WP Error", error.error);
          this.utilities.hideLoader();
        });
    } else {
      this.appService.getByPostId(postId).then(
        (res) => {
          // this.content = res[0].content.rendered;
          this.storage.set("app_intro", res);
        },
        (err) => {
          this.utilities.hideLoader();
        }
      );
    }
  }

  getWordPressNews() {
    if (this.utilities.isDeviceiOS()) {
      this.http
        .get(
          APIS.WP_BASEURL + "?categories=227&page=1&per_page=100&_embed",
          {},
          {}
        )
        .then((data) => {
          this.storage.set("news", JSON.parse(data.data));
        })
        .catch((error) => {
          // console.log(error.error); // error message as string
        });

      this.http
        .get(
          APIS.WP_BASEURL + "?categories=228&page=1&per_page=100&_embed",
          {},
          {}
        )
        .then((data) => {
          // console.log("wordpress header news:- ", data);

          this.storage.set("news_header", JSON.parse(data.data));
        })
        .catch((error) => {
          // console.log(error.error); // error message as string
        });
    } else {
      this.appService.getWordPressCategory(227).subscribe(
        (news) => {
          this.storage.set("news", news);
        },
        (err) => {
          // console.log("Wordpress api Error news: ", JSON.stringify(err));
        }
      );
      this.appService.getWordPressCategory(228).subscribe(
        (news) => {
          this.storage.set("news_header", news);
        },
        (err) => {
          // console.log("Wordpress api Error news1: ", JSON.stringify(err));
        }
      );
    }
  }

  getDeviceLanguage() {
    this.globalization
      .getPreferredLanguage()
      .then((res) => {
        try {
          if (res && JSON.parse(JSON.stringify(res)).value) {
            const lang: string = JSON.parse(JSON.stringify(res)).value.split(
              "-"
            )[0];
            if (lang !== null || lang !== undefined || lang !== "") {
              this.deviceLanguage = lang;
              this.translate.use(this.deviceLanguage);
            } else {
              this.translate.use(LANGUAGE.EN);
            }
          }
        } catch (e) {
          this.translate.use(LANGUAGE.EN);
        }
      })
      .catch((e) => {
        e;
        this.translate.use(LANGUAGE.EN);
      });
  }

  openLink(url) {
    this.iab.create(url, "_blank", "location=yes");
  }

  appIntro() {
    this.router.navigate(["plan-type"], {
      queryParams: { fromSideMenu: true },
    });
  }
  gotoDiet() {
    this.router.navigate(["drinks"], { queryParams: { prop: "edit" } });
  }

  goToTodaysCalorieCount() {
    this.router.navigate(["todays-calorie-count"]);
  }

  errorHandler(error) {
    this.utilities.hideLoader();
    this.utilities.presentAlert(error.message);
  }

  getFoodOfTheDay(day) {
    return day
      .map((d) => d.Food + " (" + d.portion + " " + d.portion_unit + ")")
      .join(",\n");
    // return day[index] ? day[index].Food : ""
  }

  getCaloriesOfDay(day, index) {
    return day[index] ? day[index].Calories : 0;
  }

  downloadDietPlan() {
    // if (!CONSTANTS.isPlanActiveParent) {  // due to this pdf wasnot downloading
    //   return false;
    // }
    const doc = new jsPDF() as jsPDFWithPlugin;
    let jsonData = [];

    let todayDate = moment(CONSTANTS.dietDate, "DDMM").format("DDMMY");
    let tomorrowDate = moment(CONSTANTS.dietDate, "DDMM")
      .clone()
      .add(1, "days")
      .format("DDMMY");
    let dayAftertomorrowDate = moment(CONSTANTS.dietDate, "DDMM")
      .clone()
      .add(2, "days")
      .format("DDMMY");

    let getDataTodayPromise = this.appService.getDietPlans(
      CONSTANTS.isDetox,
      todayDate,
      CONSTANTS.country,
      CONSTANTS.defaultCalories
    );
    let getDataTomorrowPromise = this.appService.getDietPlans(
      CONSTANTS.isDetox,
      tomorrowDate,
      CONSTANTS.country,
      CONSTANTS.defaultCalories
    );
    let getDataDayAfterTomorrowPromise = this.appService.getDietPlans(
      CONSTANTS.isDetox,
      dayAftertomorrowDate,
      CONSTANTS.country,
      CONSTANTS.defaultCalories
    );

    Promise.all([
      getDataTodayPromise.catch((error) => {
        this.errorHandler(error);
      }),
      getDataTomorrowPromise.catch((error) => {
        this.errorHandler(error);
      }),
      getDataDayAfterTomorrowPromise.catch((error) => {
        this.errorHandler(error);
      }),
    ]).then((values) => {
      this.utilities.hideLoader();

      let todayDiets = this.utilities.parseJSON(
        this.utilities.parseString(values[0])
      ).diets;
      let tomorrowDiets = this.utilities.parseJSON(
        this.utilities.parseString(values[1])
      ).diets;
      let dayAfterTomorrowDiets = this.utilities.parseJSON(
        this.utilities.parseString(values[2])
      ).diets;

      let todayCalories = 0,
        tomorrowCalories = 0,
        dayAfterTomorrowCalories = 0;

      todayDiets.forEach((diet, index) => {
        let row = diet.message;
        let time = diet.time;

        let todayDiet = diet.data;
        let tomorrowDiet = tomorrowDiets[index].data;
        let dayAfterTomorrowDiet = dayAfterTomorrowDiets[index].data;

        let foodIteratIndex = Math.max(
          todayDiet.length,
          tomorrowDiet.length,
          dayAfterTomorrowDiet.length
        );

        for (let i = 0; i < foodIteratIndex; i++) {
          todayCalories += this.getCaloriesOfDay(todayDiet, i);
          tomorrowCalories += this.getCaloriesOfDay(tomorrowDiet, i);
          dayAfterTomorrowCalories += this.getCaloriesOfDay(
            dayAfterTomorrowDiet,
            i
          );
        }
        jsonData.push({
          row: {
            content: row,
            styles: {
              fillColor: "#FD9F33",
              textColor: "#FFF",
              fontStyle: "bold",
              halign: "center",
            },
          },

          [`${todayDate}`]: this.getFoodOfTheDay(todayDiet),
          [`${tomorrowDate}`]: this.getFoodOfTheDay(tomorrowDiet),
          [`${dayAftertomorrowDate}`]:
            this.getFoodOfTheDay(dayAfterTomorrowDiet),
        });
      });

      let columns = [
        { header: "", dataKey: "row" },
        {
          header:
            moment(todayDate, "DDMM").format("dddd") +
            "\n" +
            Math.ceil(Number(todayCalories)) +
            " Kcals",
          dataKey: todayDate,
        },
        {
          header:
            moment(tomorrowDate, "DDMM").format("dddd") +
            "\n" +
            Math.ceil(Number(tomorrowCalories)) +
            " Kcals",
          dataKey: tomorrowDate,
        },
        {
          header:
            moment(dayAftertomorrowDate, "DDMM").format("dddd") +
            "\n" +
            Math.ceil(Number(dayAfterTomorrowCalories)) +
            " Kcals",
          dataKey: dayAftertomorrowDate,
        },
      ];

      doc.autoTable({
        margin: { top: 0, left: 0, right: 0, bottom: 0 },
        tableLineWidth: 1,
        tableLineColor: "#FFF",
        theme: "plain",
        body: [
          [
            { content: "", styles: { cellWidth: 50, fontSize: 14 } },
            {
              content: "Diet reccommendations for ",
              styles: {
                halign: "right",
                fillColor: "#01A3A4",
                textColor: "#FFF",
                fontSize: 14,
              },
            },
            {
              content: this.profileName,
              styles: {
                fontStyle: "bold",
                halign: "left",
                fillColor: "#01A3A4",
                textColor: "#FFF",
                fontSize: 14,
              },
            },
            { content: "", styles: { cellWidth: 50, fontSize: 14 } },
          ],
        ],
      });

      doc.autoTable({
        startY: 8,
        margin: { top: 0, left: 5, right: 5, bottom: 0 },
        tableLineWidth: 1,
        tableLineColor: "#01A3A4",
        body: JSON.parse(JSON.stringify(jsonData)),
        columns: columns,
        headStyles: {
          halign: "center",
          textColor: "#FFF",
          fillColor: "#FFF",
          cellPadding: 5,
          fontSize: 14,
        },
        bodyStyles: { valign: "middle", textColor: "#000000", fontSize: 12 },
        foot: [
          [
            {
              content:
                "This is as per https://www.smartdietplanner.com/terms-conditions/",
              colSpan: 4,
            },
          ],
        ],
        footStyles: {
          halign: "center",
          textColor: "#FFF",
          fillColor: "#01A3A4",
          fontStyle: "italic",
          cellPadding: 1,
          fontSize: 12,
        },

        didParseCell: (data) => {
          if (data.section === "head") {
            if (data.column.index === 1) data.cell.styles.fillColor = "#F9B747";
            else if (data.column.index === 2)
              data.cell.styles.fillColor = "#FF8F66";
            else if (data.column.index === 3)
              data.cell.styles.fillColor = "#FF535A";
          }

          if (data.section === "body") {
            if (data.column.index === 0) {
              // if (data.row.index < jsonData.length - 1) {
              data.cell.styles.textColor = "#FFF";
              data.cell.styles.fontStyle = "normal";
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = 5;
              data.cell.styles.fontSize = 14;
              // data.cell.styles.minCellHeight = 27;

              if (data.row.index % 2 === 0 && data.row.index > 1)
                data.cell.styles.fillColor = "#9B7F88";
              else data.cell.styles.fillColor = "#826970";
              // }
            }

            if (data.column.index === 1) {
              if (data.row.index % 2 === 0 && data.row.index > 1)
                data.cell.styles.fillColor = "#FEEFD6";
              else data.cell.styles.fillColor = "#FCE0AF";
            } else if (data.column.index === 2) {
              if (data.row.index % 2 === 0 && data.row.index > 1)
                data.cell.styles.fillColor = "#FFE6DD";
              else data.cell.styles.fillColor = "#FFCFBD";
            } else if (data.column.index === 3) {
              if (data.row.index % 2 === 0 && data.row.index > 1)
                data.cell.styles.fillColor = "#FFD9DB";
              else data.cell.styles.fillColor = "#FFB7B9";
            }
          }

          if (data.column.index > 0) data.cell.styles.cellWidth = 55;
          else data.cell.styles.cellWidth = 35;
          data.cell.styles.lineWidth = 0.5;
          data.cell.styles.lineColor = "#FFF";

          // if(data.section == "foot"){
          //   data.cell.styles.lineWidth = 0;
          // }
        },

        didDrawCell: (data) => {
          if (data.section === "head" && data.column.index === 0) {
            let base64Img =
              "data:image/png;base64,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";
            doc.addImage(
              base64Img,
              "PNG",
              data.cell.x + 2,
              data.cell.y + 7,
              25,
              6.5
            );
          }
        },
      });
      if (this.isIosDevice || this.isAndroidDevice) {
        let pdfOutput = doc.output();
        // using ArrayBuffer will allow you to put image inside PDF
        let buffer = new ArrayBuffer(pdfOutput.length);
        let array = new Uint8Array(buffer);
        for (var i = 0; i < pdfOutput.length; i++) {
          array[i] = pdfOutput.charCodeAt(i);
        }

        let directory = this.isIosDevice
          ? this.file.cacheDirectory
          : this.file.externalApplicationStorageDirectory;

        let fileName = "DietPlan_" + new Date().getTime() + ".pdf";
        //Writing File to Device
        this.file
          .writeFile(directory, fileName, buffer)
          .then((success) => {
            // console.log("File created Succesfully" + JSON.stringify(success));
            this.fileOpener
              .open(success.nativeURL, "application/pdf")
              .then(() => console.log("File is opened"))
              .catch((e) => console.log("Error opening file", e));
          })
          .catch((error) =>
            console.log("Cannot Create File " + JSON.stringify(error))
          );
      } else {
        doc.save("Diet Plan.pdf");
      }
    });
  }

  async setupFCM() {
    console.log('FCM setup started');

    if (!this.platform.is('cordova')) {
      return;
    }
    console.log('In cordova platform');

    console.log('Subscribing to token updates');
    this.firebaseX.grantPermission().then((permission)=>{
      console.log('grantPermission to token updates ', permission);
      this.firebaseX.getAPNSToken().then(() => {
        console.log('getAPNSToken to token updates');
        this.firebaseX.getToken()
          .then(token => console.log(`The token is ${token}`)) // save the token server-side and use it to push notifications to this device
          .catch(error => console.error('Error getting token', error));
      });
    });
    this.firebaseX.onMessageReceived()
      .subscribe(data => console.log(`User opened a notification ${data}`));

    this.firebaseX.onTokenRefresh()
      .subscribe((token: string) => console.log(`Got a new token ${token}`));

    // this.pushPayload = await this.firebaseX.getInitialPushPayload();
    // console.log('getInitialPushPayload result: ', this.pushPayload);
  }

}

interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    // console.log(error);
  }
}
